import { BAM_PAYWALL_IFRAME_ID } from 'constants';
import { AuthTypes } from 'enums';
import { contentSelect, streamSelect } from 'common/actions/appActions';
import { createDTCPaywallAction } from 'common/actions/authenticationActions';
import {
    streamHasAuthType,
    isStreamStatus,
    isUserAuthenticated,
    getFirstStreamUserAuth
} from 'lib/auth';
import { openStreamPicker } from 'lib/streamPicker';

/**
 * Multi stream authentication rules
 * 1. stream is upcoming, show DSS paywall
 * 2. show picker if showPicker is set to true
 * 3. select first stream for authentication
 */
export async function handleMultipleStreamAuthentication(args) {
    const { 
        nextSelectedContent,
        dispatch,
        showPicker,
        pickerStreams = [],
        authRes= {},
        locationBeforeTransitions,
        lang,
        country
    } = args;
    
    const { streams = [] } = nextSelectedContent;
    const firstStream = streams[0] || {};
    
    if (isStreamStatus(firstStream, 'upcoming')) {
        dispatch(createDTCPaywallAction({
            containerId: BAM_PAYWALL_IFRAME_ID,
            content: nextSelectedContent,
            stream: firstStream
        }));
    } else if (showPicker) {
        openStreamPicker({
            lang,
            country,
            dispatch,
            pickerStreams,
            authRes,
            content: nextSelectedContent,
            route: { locationBeforeTransitions }
        });
    } else {
        /**
         * if showPicker is not true and this is multi streams content, we will first
         * check if user is authenticated any of the streams, getFirstStreamUserAuth will
         * returns first stream user is authenticated. If user is not authenticated any of
         * streams, we will get the first stream (streams[0]) from streams
         */
        const { userAuth = [] } = authRes;
        const selectedFirstStream = getFirstStreamUserAuth(streams, userAuth) || firstStream;       
        dispatch(contentSelect(selectedFirstStream));
    } 
};


// WEBPACK FOOTER //
// ./app/lib/streamPicker/handleMultipleStreamAuthentication.js